import $ from 'jquery';
import './utils/initImages';


import header from './modules/header';
import mobileMenu from './modules/mobileMenu';
import modal from './modules/modal';
//import form from './modules/form';
import accordion from './modules/accordion';
import respImg from './modules/responsiveImages';
import lazyLoad from './modules/lazyLoad';
import scrollTo from './modules/scrollTo';
import selectWrap from './modules/selectWrap';
import sliders from './modules/sliders';
import coverScreen from './modules/coverScreen';
import langBar from './modules/langBar';
import './modules/tables';
import './modules/portfolio';
import './modules/productsList';
import './modules/lightbox';
import './modules/scrollButton';
import './modules/contactButton';
import './modules/tracking';
//import cookieMessage from './modules/cookieMessage';
import googleMap from './modules/googleMap';
//import wpforms from './modules/wpforms';
//import stickybits from 'stickybits';
//import fancyBox from '@fancyapps/fancybox';
//
import './jssocials-1.4.0/src/jssocials.js';
import './jssocials-1.4.0/src/jssocials.shares.js';
import onboarding from './modules/onboarding';

import 'svgxuse';
import './utils/init-icons';
import './utils/vh';
import './utils/supported';
import browsers from './utils/browsers';

jQuery(function () {

    if (browsers.ie && browsers.ie <= 11) {
        $('body').addClass('ie');
    }

    header.init();
    // menu.init();
    // postslist.init();
    accordion.init();
    modal.init();
    // form.init();
    selectWrap.init();
    mobileMenu.init();
    coverScreen.init();
    langBar.init();
    sliders.init();

    $('a[href^="#"]').click(function (event) {
        event.preventDefault();
        const hash = $(this).attr('href').replace('#', '');
        if (hash) {
            let el = $('#' + hash);
            if (hash == "cookie-settings") {
                if (window.CookieScript) {
                    CookieScript.instance.show();

                }
            } else if (el.length) {
                scrollTo(el.first());
            } else if (hash == "up") {
                scrollTo(0);
            } else if (hash == "next") {
                let nextLayout = $(this).closest('.layout').next('.layout');
                if (nextLayout.length) {
                    var pos = nextLayout.offset().top - parseInt(nextLayout.css('marginTop'));
                    scrollTo(pos);
                }
            }
        }
    });

    $('input,textarea').on('animationstart', function (e) {
        var name = e.originalEvent.animationName;
        if (name == "onAutoFillStart") {
            $(this).trigger('change');
        }
    });

    $('[data-video-wrap]').each(function () {
        var f = $(this).find('iframe').first();
        var w = parseInt(f.attr('width'));
        var h = parseInt(f.attr('height'));
        var pb = (100 * h / w).toFixed(2);
        $(this).css('paddingBottom', pb + '%');
    });

    jsSocials.setDefaults({
        showLabel: false,
        showCount: false,
    });

    jsSocials.shares.facebook.logo = "fab fa-facebook-f";
    jsSocials.shares.linkedin.logo = "fab fa-linkedin-in";

    $('[data-social-share]').jsSocials({
        shares: ["linkedin", "facebook"]
    });

    $('[data-google-map-location]').on('click', function () {
        var el = $(this);
        var root = $(this).closest('.layout.google-map');
        if (el.hasClass('active')) {
            root.find('[data-google-map-location]').removeClass('active');
            googleMap.setMapLocation(root);
        } else {
            root.find('[data-google-map-location]').removeClass('active');
            el.addClass('active');
            googleMap.setMapLocation(root, $(this).data('google-map-location'));
        }

    });

    $(document).on('focusin focusout', 'label.checkbox input', function (e) {
        var el = $(this).parent().closest('.checkbox');
        el.toggleClass('focus', e.type == "focusin");
    });

    $(document).on('focusin focusout', '.formfield input, .formfield select, .formfield textarea', function (e) {
        var ff = $(this).closest('.formfield').toggleClass('focus', e.type == "focusin");
    });

    $('.forminator-select').on('change', function () {
        $(this).toggleClass('empty', this.selectedIndex === 0);
    }).trigger('change');

    respImg.init();
    lazyLoad.init();
    onboarding.init();

});
